import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Gheader } from './Gheader';
import styles from './Rate.module.css';
import FilterButton from './FilterButton';
import RateTable from './RateTable';
import RateModel from './RateModel';
import apiService from '../api/apiService';

export const Rate = () => {
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [rateData, setRateData] = useState([]);

  const addRate = newRate => {
    setRateData([newRate, ...rateData]);
  };

  /* Fetching Rates from endpoint and updating local state */
  useEffect(() => {
    fetchRates();
  }, []);

  const fetchRates = async () => {
    try {
      const response = await apiService.get('/rates/');
      console.log(response);
      setRateData(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3 className="ps-2 ps-md-0">Rate</h3>
          <div className={`${styles.buttonContainer} ps-2 ps-md-0`}>
            <button
              className={styles.addRateButton}
              onClick={() => setIsModelOpen(true)}
            >
              Add rate
            </button>
            <FilterButton />
          </div>

          <RateTable data={rateData} setData={setRateData} />

          {isModelOpen && (
            <RateModel
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              onSave={addRate}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Rate;
